import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import T from 'i18n-react';
// Services
import UserService from '../../services/UserService';
// Composants
import Divider from 'material-ui/Divider';
import KeyboardArrowUpLeft from 'react-material-icons/icons/hardware/keyboard-arrow-left';
import NotificationSystem from 'react-notification-system';
import UserForm from "../../components/userForm/UserForm";
// Style
import './AddUserPage.css';
// Utils
import {notificationStyle} from '../../utils/NotificationUtils';
// Enum
import PAGES from '../../enums/PageEnum';
import PROFILES from '../../enums/ProfileEnum';

const mapStateToProps = (state) => ({
    userClient: state.userState.userData.clientList,
    userBu: state.userState.userData.businessUnitList,
    userShop: state.userState.userData.shopList,
    userData: state.userState.userData
});

class AddUserPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userFormError: null
        }
    }

    /**
     * On set le system de notification
     */
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    render() {
        const profileMap = UserService.getAvailableProfileForUser(this.props.userProfile);
        const userFormData = this.getUserFormData();
        return(
            <div className="addUserPage">
                <div className="headerAddUserPage">
                    <span className="headerTitleAddUser">{T.translate('menuTop.addUser')}</span>
                </div>
                <Divider/>
                <div className="contentAddUserPage">
                    <div className="addUserBackLinkContainer">
                        <Link to={PAGES.USER_MANAGER} className="addUserBackLink">
                            <KeyboardArrowUpLeft/>
                            <span>{T.translate('addUser.back')}</span>
                        </Link>
                    </div>
                    <div className="addUserContainer">
                        <div>
                            <UserForm ref="userForm"
                                      isCreating={true}
                                      isAdmin={this.props.userProfile === PROFILES.ADMIN_MP}
                                      profileMap={profileMap}
                                      userData={userFormData}
                                      userFormError={this.state.userFormError}
                                      onSubmit={this.onUserFormSubmit}
                                      connectedUserInformation={this.props.userData}
                                      clearError={this.clearFormError}/>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
            </div>
        );
    }

    getUserFormData = () => {
        //Si il n'a qu'un seul client on l'envoie
        if(this.props.userClient.length === 1){
            //Si il n'a qu'une seule BU on l'envoie
            if(this.props.userBu.length === 1) {
                //Si il n'a qu'un seul Shop, en l'envoie
                if (this.props.userShop.length === 1) {
                    return {
                        client: this.props.userClient[0],
                        bu: this.props.userBu[0],
                        shop: this.props.userShop[0]
                    };
                } else {
                    return {
                        client: this.props.userClient[0],
                        bu: this.props.userBu[0]
                    }
                }
            } else {
                return {
                    client: this.props.userClient[0],
                };
            }
        }
    };

    onUserFormSubmit = (formData) => {
        UserService.addUser(formData)
            .then(res => {
                // Si l'ajout de l'utilisateur a échoué on ajoute une erreur dans le formulaire
                // (Au dessus du bouton "Submit")
                if (res.errorCode) {
                    this.setState({
                        userFormError: `userForm.submitErrors.${res.errorCode}`
                    });
                } else {
                    // Sinon on ajoute un toastr de notification et on clear le formulaire
                    this._addNotification(T.translate('userForm.userSuccessfullyAdded'), 'success');
                    this.refs.userForm.clearForm();
                }
            })
            .catch(() => {
                this.setState({
                    userFormError: 'userForm.submitErrors.unexpected'
                });
            });
    };

    clearFormError = () => this.setState({userFormError: null});

    /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification = (message, level) => {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 5,
            level,
            position: 'tr'
        });
    }

}

export default connect(mapStateToProps)(AddUserPage);



// WEBPACK FOOTER //
// ./src/ui/addUser/AddUserPage.js